import _ from 'lodash'
import { nanoid } from 'nanoid'
import moment from 'moment-timezone'
import router from '@/router/_'
import { GrupoOpmeTipoEnum, LembreteEnum, TipoGradeHorarioEnum, GradeMedicaEvento, TipoReservaSalaEnum, SituacaoEnum, User as Usr } from '@/types/_'
import ComplexidadeEnum from '@/types/enum/ComplexidadeEnum'
import { pdfService } from '@/services/pdf.service'
import EventBus from '@/plugins/EventBus'


const getRoute = () => router.currentRoute
const backofficeRoute = () => (getRoute() as any).meta.area

// TIMEOUT apenas para finalidade de testes...
const timeout = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
const timeoutDefault = async () => new Promise(resolve => setTimeout(resolve, 400))

const adjustTZ = (date: string) => moment.tz(date, 'Europe/London').clone().tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')

const capitalizeCase = (value: string) => _.startCase(_.toLower(value))

const splitUppercase = (value: string) => value.split(/(?=[A-Z])/).join(' ')

const humanTime = (dateTime: string) => {
  const d = new Date(dateTime)
  const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate()
  const year = d.getFullYear()
  const month = (d.getMonth() + 1) < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1
  const hours = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours()
  const minutes = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()
  const fullDate = `${day}/${month}/${year} ${hours}:${minutes}`

  return fullDate
}

const formatDateTimePost = (date: any) => {
  if (!date) return null

  let day: any = new Date(Date.parse(date)).getDate()
  let month: any = new Date(Date.parse(date)).getMonth() + 1
  const year: any = new Date(Date.parse(date)).getFullYear()
  let h: any = new Date(Date.parse(date)).getHours()
  let m: any = new Date(Date.parse(date)).getMinutes()

  day = day < 10 ? `0${day}` : day
  month = month < 10 ? `0${month}` : month
  h = h < 10 ? `0${h}` : h
  m = m < 10 ? `0${m}` : m

  return `${year}-${month}-${day}T${h}:${m}`
}

const instrumentador = (profile) => {
  if (profile && profile.roles) {
    if (Array.isArray(profile.roles)
      && profile.roles.some(c => _.toUpper(c) === 'INSTRUMENTADOR')) {
      return true
    }

    if (_.toUpper(profile.roles) === 'INSTRUMENTADOR') {
      return true
    }
  }

  return false
}

const assinarEnviar = (profile) => {
  if (profile && profile.roles) {
    if (Array.isArray(profile.roles)
      && profile.roles.some(c => _.toUpper(c) === 'ASSINARENVIAR')) {
      return true
    }

    if (_.toUpper(profile.roles) === 'ASSINARENVIAR') {
      return true
    }
  }

  return false
}

const isRolesValid = (profile, role) => {
  if (profile && profile.roles) {
    if (
      Array.isArray(profile.roles)
      && profile.roles.some(c => _.toUpper(c) === _.toUpper(role))
    ) {
      return true
    }

    if (_.toUpper(profile.roles) === _.toUpper(role)) {
      return true
    }
  }

  return false
}

const dateToTimestamp = (date: any) => {
  if (date) {
    return moment(date, 'DDMMYYYYHHmm').format('YYYY-MM-DDTHH:mm')
  }
  return null
}

const lightenDarkenColor = (colorCode: string, amount: number) => {
  let usePound = false
  let inputColor = colorCode

  if (colorCode[0] === '#') {
    inputColor = colorCode.slice(1)
    usePound = true
  }

  const num = parseInt(inputColor, 16)

  let r = (num >> 16) + amount // eslint-disable-line no-bitwise

  if (r > 255) {
    r = 255
  } else if (r < 0) {
    r = 0
  }

  let b = ((num >> 8) & 0x00FF) + amount // eslint-disable-line no-bitwise

  if (b > 255) {
    b = 255
  } else if (b < 0) {
    b = 0
  }

  let g = (num & 0x0000FF) + amount //  eslint-disable-line no-bitwise

  if (g > 255) {
    g = 255
  } else if (g < 0) {
    g = 0
  }

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16) // eslint-disable-line no-bitwise
}

const formatDate = (date) => {
  if (date.length === 8) {
    const day = date.substring(0, 2)
    const month = date.substring(2, 4)
    const year = date.substring(4, 8)
    const dateFormat = `${year}-${month}-${day}`
    return dateFormat
  }
  return ''
}

const formatDateOnly = (date: any) => {
  if (date) {
    return moment(date).format('DD/MM/YY')
  }

  return ''
}

const ptBrDateStringToDate = (date: string, separatorChar = '/') => {
  if (!date) return null

  const [day, month, year] = date.split(separatorChar)
  return new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`)
}

const formatDateGetApi = (date) => {
  if (date) {
    return new Date(moment(date, 'YYYY-MM-DDTHH:mm').toString())
  }
  return null
}

const onlyAlphaNumeric = (input) => {
  const numberPattern = /[ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-]+/ig
  const result = input.key.match(numberPattern)
  if (!result) {
    input.preventDefault()
    return false
  }

  return input
}

const onlyNumber = (input) => {
  const numberPattern = /\d+/g
  const result = input.key.match(numberPattern)
  if (!result) {
    input.preventDefault()
    return false
  }

  return input
}

const onlyNumberAndNewLine = (input) => {
  const numberPattern = /\d+/g
  const result = input.key.match(numberPattern) || input.key === 'Enter'
  if (!result) {
    input.preventDefault()
    return false
  }

  return input
}

const onlyFloat = (input, comma: boolean = false) => {
  const numberPattern = comma ? /[0-9,]/g : /[0-9\.]/g
  const result = input.key.match(numberPattern)
  if (!result) {
    input.preventDefault()
    return false
  }

  return input
}

// eslint-disable-next-line
const isDecimal = (value: string, formato: string = 'en-US') => isNaN(+new Intl.NumberFormat(formato, { style: 'decimal', useGrouping: false }).format(+value))

const isDateValid = (date) => {
  const day = date.substring(0, 2)
  const month = date.substring(2, 4)
  const year = date.substring(4, 8)
  const h = date.substring(8, 10)
  const m = date.substring(10, 12)

  if (day > 31) {
    return false
  }

  if (month > 12) {
    return false
  }

  if (year < 1970) {
    return false
  }

  if (h > 23) {
    return false
  }

  if (m > 59) {
    return false
  }

  return true
}

const maskMoney = (value: string) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return [undefined, null, '', 0].includes(value)
    ? 'R$ 0,00'
    : formatter.format(Number(value))
}

const maskDate = (date: string) => {
  if (!date) {
    return 'Não informado'
  }

  return moment(date).format('DD/MM/YYYY')
}

const maskDateMonth = (date: string) => {
  if (!date) {
    return 'Não informado'
  }

  const formattedDate = moment(date).format('MMMM/YYYY').replace(/^\w/, c => c.toUpperCase())
  return formattedDate
}

const maskHour = (date: string) => {
  if (!date) {
    return ''
  }

  return moment(date).format('HH:mm')
}

const maskDateTime = (date: string) => {
  if (date) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  return 'Não informado'
}

const maskPhone = (value: string) => {
  if (value) {
    let v = value
    v = value.replace(/\D/g, '')
    v = v.replace(/^(\d{2})(\d)/g, '($1) $2')
    v = v.replace(/(\d)(\d{4})$/, '$1-$2')
    return v
  }
  return value
}

const formatPhoneApi = (value: string) => (value ? value.trim().replace(/\D*/g, '') : value)

const formatDateTimeSendApi = (date: string) => {
  const format = moment(date).format('YYYY-MM-DDTHH:mm')
  return format
}

const groupCollectionByField = (json: any, field: string = 'dataEnvio') => {
  const data = json.reduce((newArray, element) => {
    const newData = newArray
    let group = ''

    if (maskDate(element[field]) === moment(new Date()).format('DD/MM/YYYY')) {
      group = 'Hoje'
    } else if (moment(moment(new Date()).format('YYYY-MM-DD')).diff(moment(moment(element[field]).format('YYYY-MM-DD')), 'days') === 1) {
      group = 'Ontem'
    } else {
      group = moment(element[field]).format('DD/MM/YYYY')
    }

    if (!newArray[group]) {
      newData[group] = { group, children: [element] }
    } else {
      newData[group].children.push(element)
    }
    return newData
  }, {})

  return Object.values(data)
}

const groupCollectionByDay = (json: any, field: string = 'dataAgendamento') => {
  if (json.length < 1) return []

  const data = json.reduce((newArray: any, element: any) => {
    const newData = newArray
    let dia = ''

    dia = moment(element[field]).format('YYYY-MM-DD')

    if (!newArray[dia]) {
      newData[dia] = { dia, children: [element] }
    } else {
      newData[dia].children.push(element)
    }
    return newData
  }, {})

  return Object.values(data)
}

const groupCollectionByWeek = (json: any, field: string = 'dataAgendamento') => {
  if (json.length < 1) return []

  const data = json.reduce((newArray: any, element: any) => {
    const newData = newArray
    let semana = ''

    semana = `${capitalizeCase(moment(element[field]).startOf('week').format('MMM DD'))} - ${capitalizeCase(moment(element[field]).endOf('week').format('MMM DD'))}`

    if (!newArray[semana]) {
      newData[semana] = { semana, children: [element] }
    } else {
      newData[semana].children.push(element)
    }
    return newData
  }, {})

  return Object.values(data)
}

const groupCollectionByMonth = (json: any, field: string = 'dataAgendamento') => {
  if (json.length < 1) return []

  const groupByMonth = json.reduce((newArray: any, element: any) => {
    const newData = newArray
    let mes = ''

    mes = moment(element[field]).format('MMMM')

    if (!newArray[mes]) {
      newData[mes] = { mes, children: [element] }
    } else {
      newData[mes].children.push(element)
    }
    return newData
  }, {})

  return Object.values(groupByMonth)
}

const toggleHtmlOverflow = (isOpen: Boolean) => {
  const html = document.querySelector('html')
  const noOverflowClass = 'modal-is-open'

  if (html !== null) {
    html.classList.remove(noOverflowClass)
    if (isOpen) {
      html.classList.toggle(noOverflowClass)
      document.getElementsByClassName('v-dialog')[0].scrollTop = 0
    }
  }
}

const displayColorPrestadorRecebimentoBySituation = (value: string) => {
  switch (value) {
    case 'Pendente':
      return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }

    case 'Divergente':
    case 'ValidacaoPendente':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'Validada':
    case 'Paga':
      return { background: 'green lighten-4', text: 'green darken-4' }

    default:
      return { background: '', text: '' }
  }
}

const displayColorCalculoRecebimentoBySituation = (value: string) => {
  switch (value) {
    case 'Calculado':
      return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }

    case 'Divergente':
    case 'Descartado':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'Validado':
    case 'Pago':
    case 'RepasseGerado':
      return { background: 'green lighten-4', text: 'green darken-4' }

    default:
      return { background: '', text: '' }
  }
}

const displayColorBySituation = (value: string) => {
  switch (value) {
    case 'AguardandoPrazoPosTriagem':
      return { background: 'orange darken-4', text: 'orange lighten-5' }

    case 'PreAgendamento':
      return { background: 'pink lighten-4', text: 'pink darken-5' }

    case 'RevisaoCirurgica':
      return { background: 'pink accent-3', text: 'pink lighten-5' }

    case 'RevisaoCirurgicaAutorizacao':
      return { background: 'pink accent-3', text: 'pink lighten-5' }

    case 'Enviado':
      return { background: 'deep-purple lighten-4', text: 'deep-purple darken-4' }

    case 'Incompleta':
      return { background: 'grey lighten-1', text: 'grey darken-4' }

    case 'PreviaCirurgica':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'DisponivelParaEnvio':
      return { background: 'green lighten-2', text: 'green darken-4' }

    case 'Autorizada':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'AnalisePreAutorizacao':
      return { background: 'purple lighten-4', text: 'purple darken-2' }

    case 'AnalisePreAutorizacaoUrgencia':
      return { background: 'purple lighten-5', text: 'purple darken-2' }

    case 'AnalisePreCotacao':
      return { background: 'deep-purple lighten-5', text: 'deep-purple darken-3' }

    case 'AnalisePosCotacao':
      return { background: 'deep-purple lighten-5', text: 'deep-purple darken-3' }

    case 'EmAutorizacao':
      return { background: 'purple lighten-4', text: 'purple darken-2' }

    case 'AguardandoAutorizacaoUrgencia':
      return { background: 'blue lighten-5', text: 'blue darken-4' }

    case 'Pendente':
      return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }

    case 'PendenciaAdministrativa':
      return { background: 'deep-orange lighten-3', text: 'deep-orange darken-4' }

    case 'PendenciaRespondida':
      return { background: 'light-green lighten-4', text: 'light-green darken-4' }

    case 'EmTriagem':
      return { background: 'cyan lighten-4', text: 'cyan darken-4' }

    case 'AlteracaoDeCarater':
      return { background: 'cyan lighten-4', text: 'cyan darken-4' }

    case 'AguardandoOperadora':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'AguardandoIntegracaoOperadora':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'ErroIntegracaoOperadora':
      return { background: '#CE5555', text: '#FFFFFF' }

    case 'CriticaOperadora':
      return { background: '#E6D942', text: '#796F00' }

    case 'EmCotacao':
      return { background: 'brown lighten-4', text: 'brown darken-4' }

    case 'AguardandoSuprimentos':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'RetornoDeCotacao':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-4' }

    case 'LiberadoSuprimentos':
      return { background: 'pink lighten-4', text: 'pink darken-4' }

    case 'AutorizadaParcial':
      return { background: 'indigo lighten-4', text: 'indigo darken-2' }

    case 'AutorizadaAceitaMedico':
      return { background: 'green lighten-4', text: 'green darken-2' }

    case 'ContestacaoMedica':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-2' }

    case 'ContestacaoPendente':
      return { background: 'amber lighten-5', text: 'amber darken-4' }

    case 'AguardandoReservaHis':
      return { background: 'teal lighten-4', text: 'teal darken-2' }

    case 'ReenvioDeReservaHis':
      return { background: 'teal lighten-3', text: 'teal darken-2' }

    case 'AguardandoAlteracaoDeReservaHis':
      return { background: 'cyan lighten-4', text: 'cyan darken-2' }

    case 'ErroReservaHis':
      return { background: 'deep-orange lighten-4', text: 'deep-orange darken-2' }

    case 'ErroAoAlterarReservaHis':
      return { background: 'red accent-3', text: 'white' }

    case 'Cancelada':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'CancelamentoSolicitado':
      return { background: 'pink lighten-5', text: 'pink darken-4' }

    case 'RetornoDaAutorizacaoDoHis':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'RespostaDoRoboDeAutorizacao':
      return { background: 'deep-purple lighten-4', text: 'deep-purple darken-2' }

    case 'TransferenciaReserva':
      return { background: 'blue lighten-5', text: 'blue darken-3' }

    /* Situações da remuneração */
    case 'Divergente':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'Provisionada':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'ValidacaoPendente':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'Validada':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'Paga':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'EnviadoParaPagamento':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'CobrancaNotaFiscalForadoPrazo':
      return { background: 'red-orange lighten-4', text: 'red-orange darken-4' }

    case 'ProvisionamentoNotaFiscalNaoEmitir':
      return { background: 'deep-orange lighten-4', text: 'deep-orange darken-4' }

    case 'CobrancaNotaFiscal':
      return { background: 'deep-orange lighten-4', text: 'deep-orange darken-4' }

    case 'DivergenciaNotaFiscal':
      return { background: 'deep-orange lighten-4', text: 'deep-orange darken-4' }

    case 'ProvisionamentoNotaFiscalCancelar':
      return { background: 'red-orange lighten-4', text: 'red-orange darken-4' }

    case 'NotaFiscalUploadRecebido':
      return { background: 'green-orange lighten-4', text: 'green-orange darken-4' }

    /* Situações da fidelização */
    case 'ProtocoloAderente':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'ProtocoloNaoAderente':
      return { background: 'red accent-3', text: 'white' }

    case 'FidelizacaoAceitouJustificativa':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'ProtocoloAceito':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'ProtocoloRecusado':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'PendenciaDeProtocolo':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'PendenciaDeProtocoloExpirada':
      return { background: 'red accent-3', text: 'white' }

    case 'EncaminhadoPelaRegulacao':
      return { background: 'grey lighten-1', text: 'grey darken-4' }

    case 'AutorizadaPelaRegulacao':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'AutorizadaParcialPelaRegulacao':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'AutorizacaoNegadaPelaRegulacao':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'doctorUpdate':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    /* Farmácia */
    case 'PendenteReserva':
      return { background: 'purple lighten-4', text: 'purple darken-2' }

    case 'PendenteAjusteData':
      return { background: 'deep-purple lighten-5', text: 'deep-purple darken-3' }

    case 'PendenteAjusteMaterial':
      return { background: 'pink lighten-5', text: 'pink darken-4' }

    case 'PendenteCancelamento':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'Concluido':
      return { background: 'green lighten-2', text: 'green darken-4' }

    case 'IntegracaoNegadaPeloAutorizador':
      return { background: 'deep-orange lighten-5', text: '#292929' }

    case 'LiberadoParaAgendamento':
      return { background: 'light-green lighten-4', text: '#292929' }

    case 'AutorizacaoNegadaPeloAutorizador':
      return { background: 'deep-orange lighten-3', text: 'deep-orange darken-4' }

    case 'EnviadoParaOAutorizador':
      return { background: 'light-blue lighten-4', text: '#292929' }

    case 'ExigenciaDoAutorizador':
      return { background: 'light-blue lighten-4', text: '#292929' }

    case 'HistoricoOvermind':
      return { background: 'amber lighten-4', text: 'amber darken-3' }

    /* Orçamento */
    case 'AguardandoOrcamento':
      return { background: 'deep-purple lighten-4', text: 'deep-purple darken-4' }

    case 'NovoOrcamentoParticular':
      return { background: 'teal lighten-4', text: 'teal darken-4' }

    case 'AguardandoAprovacaoOrcamento':
      return { background: 'amber lighten-5', text: 'amber darken-4' }

    case 'OrcamentoAprovado':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-2' }

    case 'OrcamentoRecusado':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'AguardandoGeracaoDaCobranca':
      return { background: 'light-blue lighten-4', text: 'light-blue darken-4' }

    case 'AguardandoPagamento':
      return { background: 'lime lighten-4', text: 'lime darken-4' }

    case 'OrcamentoCancelado':
      return { background: 'red accent-3', text: 'white' }

    default:
      return { background: '', text: '' }
  }
}

const displayColorByStatus = (value: string) => {
  switch (value.toLowerCase()) {
    /* Situações da fidelização */
    case 'protocoloaderente':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'encaminhadopelaregulacao':
      return { background: 'grey lighten-1', text: 'grey darken-4' }

    case 'protocolonaoaderente':
      return { background: 'red accent-3', text: 'white' }

    case 'fidelizacaoaceitoujustificativa':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'protocoloaceito':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'protocolorecusado':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'pendenciadeprotocolo':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'preagendamento':
      return { background: 'pink lighten-4', text: 'pink darken-5' }

    case 'revisaocirurgica':
      return { background: 'pink accent-3', text: 'pink lighten-5' }

    case 'revisaocirurgicaautorizacao':
      return { background: 'pink accent-3', text: 'pink lighten-5' }

    case 'enviado':
      return { background: 'deep-purple lighten-4', text: 'deep-purple darken-4' }

    case 'analisepreautorizacaourgencia':
      return { background: 'purple lighten-5', text: 'purple darken-2' }

    case 'analisepreautorizacao':
      return { background: 'purple lighten-4', text: 'purple darken-2' }

    case 'analiseprecotacao':
      return { background: 'deep-purple lighten-5', text: 'deep-purple darken-3' }

    case 'incompleta':
      return { background: 'grey lighten-1', text: 'grey darken-4' }

    case 'autorizada':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'pendentederetornodautorizacao':
      return { background: 'green lighten-4', text: 'green darken-2' }

    case 'retornodaautorizacaodohis':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'respostadorobodeautorizacao':
      return { background: 'deep-purple lighten-4', text: 'deep-purple darken-2' }

    case 'emautorizacao':
      return { background: 'purple lighten-4', text: 'purple darken-2' }

    case 'aguardandoautorizacaourgencia':
      return { background: 'blue lighten-5', text: 'blue darken-4' }

    case 'pendentedeenviorobodeautorizacao':
      return { background: 'deep-orange lighten-5', text: 'deep-orange darken-3' }

    case 'pendente':
      return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }

    case 'pendenciaadministrativa':
      return { background: 'deep-orange lighten-3', text: 'deep-orange darken-4' }

    case 'pendenciarespondida':
      return { background: 'light-green lighten-4', text: 'light-green darken-4' }

    case 'emtriagem':
      return { background: 'cyan lighten-4', text: 'cyan darken-4' }

    case 'alteracaodecarater':
      return { background: 'cyan lighten-4', text: 'cyan darken-4' }

    case 'aguardandooperadora':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'aguardandointegracaooperadora':
      return { background: 'blue lighten-4', text: 'blue darken-4' }

    case 'errointegracaooperadora':
      return { background: '#CE5555', text: '#FFFFFF' }

    case 'criticaoperadora':
      return { background: '#E6D942', text: '#796F00' }

    case 'emcotacao':
      return { background: 'brown lighten-4', text: 'brown darken-4' }

    case 'analiseposcotacao':
      return { background: 'brown lighten-2', text: 'brown darken-4' }

    case 'retornodecotacao':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-4' }

    case 'autorizadaparcial':
      return { background: 'indigo lighten-4', text: 'indigo darken-2' }

    case 'autorizadaaceitamedico':
      return { background: 'green lighten-4', text: 'green darken-2' }

    case 'aguardandoreservahis':
      return { background: 'teal lighten-4', text: 'teal darken-2' }

    case 'aguardandoalteracaodereservahis':
      return { background: 'cyan lighten-4', text: 'cyan darken-2' }

    case 'erroreservahis':
      return { background: 'deep-orange lighten-4', text: 'deep-orange darken-2' }

    case 'erroaoalterarreservahis':
      return { background: 'red accent-3', text: 'white' }

    case 'contestacaomedica':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-2' }

    case 'contestacaopendente':
      return { background: 'amber lighten-5', text: 'amber darken-4' }

    case 'cancelada':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'cancelamentosolicitado':
      return { background: 'pink lighten-5', text: 'pink darken-4' }

    case 'apto':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'naoapto':
      return { background: 'pink lighten-5', text: 'pink darken-4' }

    case 'aptocomatencao':
      return { background: 'cyan lighten-4', text: 'cyan darken-4' }

    case 'contatopendente':
      return { background: 'brown lighten-4', text: 'brown darken-4' }

    case 'aguardandopaciente':
      return { background: 'indigo lighten-4', text: 'indigo darken-2' }

    case 'coletarealizada':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-2' }

    case 'testependente':
      return { background: 'amber lighten-5', text: 'amber darken-4' }

    case 'aguardandoSuprimentos':
      return { background: 'green lighten-4', text: 'green darken-4' }

    case 'liberadoSuprimentos':
      return { background: 'teal lighten-4', text: 'teal darken-4' }

    case 'aguardandoorcamento':
      return { background: 'deep-purple lighten-4', text: 'deep-purple darken-4' }

    case 'novoorcamentoparticular':
      return { background: 'teal lighten-4', text: 'teal darken-4' }

    case 'aguardandoaprovacaoorcamento':
      return { background: 'amber lighten-5', text: 'amber darken-4' }

    case 'orcamentoaprovado':
      return { background: 'blue-grey lighten-4', text: 'blue-grey darken-2' }

    case 'orcamentorecusado':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'aguardandogeracaodacobranca':
      return { background: 'light-blue lighten-4', text: 'light-blue darken-4' }

    case 'aguardandopagamento':
      return { background: 'lime lighten-4', text: 'lime darken-4' }

    case 'orcamentocancelado':
      return { background: 'red accent-3', text: 'white' }

    case 'aguardandoprazopostriagem':
      return { background: 'orange darken-4', text: 'orange lighten-5' }

    case 'pendentereserva':
      return { background: 'purple lighten-4', text: 'purple darken-2' }

    case 'pendenteajustedata':
      return { background: 'deep-purple lighten-5', text: 'deep-purple darken-3' }

    case 'pendenteajustematerial':
      return { background: 'pink lighten-5', text: 'pink darken-4' }

    case 'pendentecancelamento':
      return { background: 'red lighten-5', text: 'red darken-2' }

    case 'concluido':
      return { background: 'green lighten-2', text: 'green darken-4' }

    case 'integracaonegadapeloautorizador':
      return { background: 'deep-orange lighten-5', text: '#292929' }

    case 'liberadoparaagendamento':
      return { background: 'light-green lighten-4', text: '#292929' }

    case 'autorizacaonegadapeloautorizador':
      return { background: 'deep-orange lighten-3', text: 'deep-orange darken-4' }

    case 'enviadoparaoautorizador':
      return { background: 'light-blue lighten-4', text: '#292929' }

    case 'exigenciadoautorizador':
      return { background: 'light-blue lighten-4', text: '#292929' }
    default:
      return { background: '', text: '' }
  }
}

const displayColorByStatusGeracaoRepasse = (status: string) => {
  switch (status) {
    case 'Concluido':
      return { background: 'green lighten-3', text: 'green darken-4' }
    case 'Erro':
      return { background: 'red accent-3', text: 'white' }
    case 'Em Andamento':
      return { background: 'yellow lighten-3', text: 'yellow darken-3' }
    case 'Finalizado':
      return { background: 'green lighten-3', text: 'green darken-4' }
    case 'Aguardando':
      return { background: 'blue lighten-4', text: 'blue darken-4' }
    case 'Descartado':
      return { background: 'red lighten-5', text: 'red darken-2' }
    case 'Integrando':
      return { background: 'amber lighten-4', text: 'yellow darken-3' }
    case 'Integrado':
      return { background: 'teal lighten-4', text: 'teal darken-1' }
    case 'Liberado':
      return { background: 'light-green lighten-4', text: 'light-green darken-3' }
    case 'Fechado':
      return { background: 'deep-orange lighten-4', text: 'deep-orange darken-4' }
    case 'Calculando':
      return { background: 'amber lighten-4', text: 'amber darken-3' }
    case 'Gerado':
      return { background: 'green lighten-2', text: 'green darken-4' }
    case 'Calculado':
      return { background: 'light-green lighten-4', text: 'light-green darken-3' }
    case 'Divergente':
      return { background: 'amber lighten-4', text: 'amber darken-3' }
    case 'Recalculando':
      return { background: 'blue lighten-4', text: 'blue darken-4' }
    case 'Validado':
      return { background: 'amber lighten-4', text: 'yellow darken-3' }
    default:
      return { background: '', text: '' }
  }
}

const displayCategoriaDoPlanoParaFidelizacao = (value: string) => {
  switch (value) {
    case 'indefinido':
      return 'Indefinido'

    case 'community':
      return 'Community'

    case 'outros':
      return 'Outros'

    default:
      return 'Indefinido'
  }
}

const aceiteMedicoDaAutorizacaoParcialSeAplica = (situacaoKey?: string | null) => situacaoKey === SituacaoEnum.Autorizada || situacaoKey === SituacaoEnum.AutorizadaParcial

const stringToDecimal = (value: string | null) => {
  const valor = value !== null ? value : '0,00'
  const [inteiro, centavos] = valor.split(',')
  const total = `${inteiro.split('.').join('')}.${centavos}`
  return parseFloat(total)
}

const decimalToString = (amount: number | string) => {
  const value: number = typeof amount === 'number' ? amount : stringToDecimal(amount)
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return String(formatter.format(value)).slice(3)
}

const objectKeysToCamelCase = (obj: any) => {
  const camelCaseObject = {}
  _.forEach(obj, (value: any, key: any) => {
    if (_.isPlainObject(value) || _.isArray(value)) {
      // eslint-disable-next-line
      value = objectKeysToCamelCase(value)
    }
    camelCaseObject[_.camelCase(key)] = value
  })
  return camelCaseObject
}

const getUser = () => {
  const defaultUser: Usr = {
    accessToken: '',
    expiresAt: '',
    idToken: '',
    profile: {
      authTime: '',
      email: '',
      emailVerified: [],
      name: '',
      preferredUsername: '',
      pageAuthorized: [],
      roles: [],
      sid: '',
      sub: '',
      defaultPage: {
        keyAuthorized: '',
        view: '',
      },
    },
    refreshToken: '',
    scope: '',
    sessionState: '',
    tokenType: '',
  }

  // @ts-ignore
  const item: any = localStorage.getItem(`oidc.user:${window.API_FINX_AUTH}:portal-client-2`)
  const user: any = JSON.parse(item) ? objectKeysToCamelCase(JSON.parse(item)) : defaultUser
  user.profile.emailVerified = user.profile.emailVerified || false

  if (!user.profile.roles || Array.isArray(user.profile.roles)) {
    user.profile.roles = []
  } else if (typeof user.profile.roles === 'string') {
    user.profile.roles = [user.profile.roles]
  } else {
    user.profile.roles = Object.values(user.profile.roles)
  }

  if (!user.profile.pageAuthorized || Array.isArray(user.profile.pageAuthorized)) {
    user.profile.pageAuthorized = []
  } else if (typeof user.profile.pageAuthorized === 'string') {
    user.profile.pageAuthorized = [user.profile.pageAuthorized]
  } else {
    user.profile.pageAuthorized = Object.values(user.profile.pageAuthorized)
  }


  return user
}

const getUserDefaultBackofficeArea = () => {
  const { pageAuthorized } = getUser().profile
  const view = JSON.parse(pageAuthorized.find(e => e.match(/^{/g))).view || ''
  switch (view) {
    case 'backoffice-agendamento':
      return 'agendamento'
    case 'backoffice-autorizacao':
      return 'autorizacao'
    case 'backoffice-suprimentos':
      return 'suprimentos'
    case 'backoffice-orcamento':
      return 'orcamento'
    case 'backoffice-pre-anestesico':
      return 'preanestesia'
    case 'backoffice-agencia-transfusional':
      return 'agenciatransfusional'
    case 'backoffice-regulacao':
      return 'regulacao'
    case 'operadora-fidelizacao':
      return 'fidelizacao'
    default:
      return 'agendamento'
  }
}

const validateLength = (e: any, length: number) => e && e.length && e.length >= length

const validateEmail = (email: string) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

const validateEmailForm = (email: string) => ['', undefined, null].includes(email) || validateEmail(email)

const validateTelefone = (phone: string) => {
  let parsedPhone

  if (phone && phone.includes('X')) {
    parsedPhone = phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')

    return parsedPhone.length === 10 || parsedPhone.length === 11
  }

  if (['', undefined, null].includes(phone)) return false
  parsedPhone = phone.replaceAll(/[^0-9]+/g, '')
  return parsedPhone.length === 10 || parsedPhone.length === 11
}

const validateTelefoneForm = (telefone: string) => ['', undefined, null].includes(telefone) || validateTelefone(telefone)

const validateCPF = (strCPF: string) => {
  if ([null, undefined, ''].includes(strCPF) || strCPF.length < 11) return false
  // eslint-disable-next-line
  console.error = function () { }
  const cpf = strCPF
  let soma = 0
  let resto = 0

  if ([
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ].includes(cpf)) return false

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i)
  }

  resto = (soma * 10) % 11

  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(cpf.substring(9, 10), 10)) return false

  soma = 0

  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i)
  }

  resto = (soma * 10) % 11

  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(cpf.substring(10, 11), 10)) return false

  return true
}

const validateCNPJ = (cnpjStr: string) => {
  if ([null, undefined, ''].includes(cnpjStr) || cnpjStr.length < 14) return false
  // eslint-disable-next-line
  console.error = function () { }

  if ([
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ].includes(cnpjStr)) return false

  const cnpjValidator = cnpjStr

  let tamanho: any = cnpjValidator.length - 2
  let numeros: any = cnpjValidator.substring(0, tamanho)
  const digitos: string = cnpjValidator.substring(tamanho)
  let soma: any = 0
  let pos: any = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    // eslint-disable-next-line
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }

  let resultado: any = soma % 11 < 2 ? 0 : 11 - (soma % 11)

  if (resultado.toString() !== digitos.charAt(0)) return false

  tamanho += 1
  numeros = cnpjValidator.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    // eslint-disable-next-line
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)

  if (resultado.toString() !== digitos.charAt(1)) return false

  return true
}

const validateCPFCNPJ = (cpfCnpj: string) => {
  if (cpfCnpj && cpfCnpj.length === 11) return validateCPF(cpfCnpj)
  if (cpfCnpj && cpfCnpj.length === 14) return validateCNPJ(cpfCnpj)
  return false
}

const validateDate = (date: string) => {
  if (['', undefined, null].includes(date)) return false
  return moment(date).isValid()
}

const validateGUID = (guid: string) => {
  if (['', undefined, null].includes(guid)) return false
  const pattern: RegExp = /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/
  return pattern.test(guid)
}

const tipoAnestesiaToTemp = (tipoAnestesia: any) => {
  if (tipoAnestesia) {
    return _.map(_.map(tipoAnestesia, 'tipo'), 'key')
  }
  return []
}

const outrosTipoAnestesiaToTemp = (tipoAnestesia: any) => {
  if (tipoAnestesia) {
    const result = tipoAnestesia.find(e => e.outrosTipoAnestesia !== '')
    return result.outrosTipoAnestesia
  }
  return ''
}

const formatToSendTipoAnestesia = (solicitacao: any) => {
  const o = []
  solicitacao.tipoAnestesiaTemp.forEach((e: any) => {
    if (e.toUpperCase() !== 'OUTROS') {
      // @ts-ignore
      o.push({ tipoAnestesia: e })
    } else {
      // @ts-ignore
      o.push({ tipoAnestesia: e, outrosTipoAnestesia: solicitacao.outrosTipoAnestesia })
    }
  })
  return o
}

const formatPhoneMask = (phone: string) => {
  if ([null, undefined, ''].includes(phone)) return ''
  if (phone.length < 14) return ''
  return phone.replace(/\D/gi, '')
}

const verifyEtapaAgendamento = (item: any) => [
  'enviado',
  'pendente',
  'incompleta',
  'pendenciarespondida',
  'cancelamentosolicitado',
  'cancelada',
].includes(item.situacao.key.toLowerCase())

const verifyAcoesAgendamento = (item: any) => {
  const acoes: string[] = [
    'analizarResposta',
    'agendamentoRealizaPreAgendamento',
    'agendamentoRealizaRevisaoCirurgica',
    'agendamentoRealizaTriagem',
    'agendamentoAtualizaTriagem',
    'agendamentoConfirmaCancelamento',
    'agendamentoDesfazCancelamento',
    'agendamentoFazAutorizacaoParaAgendar',
    'agendamentoFazPriorizacao',
    'confirmarData',
    'alterarData',
    'agendamentoResolvePendenciaAdministrativa',
  ]

  return acoes.some(c => item.acoes[c])
}

const verifyAcoesFarmacia = (item: any) => {
  const acoes: string[] = [
    'finalizaNaFarmacia',
  ]

  return acoes.some(c => item.acoes[c])
}

const verifyAcaoPrincipalAgendamento = (item: any) => {
  if (item.acoes.analizarResposta) {
    return 'analizarResposta'
  }

  if (item.acoes.agendamentoRealizaTriagem) {
    return 'agendamentoRealizaTriagem'
  }

  if (item.acoes.agendamentoAtualizaTriagem) {
    return 'agendamentoAtualizaTriagem'
  }

  if (item.acoes.agendamentoConfirmaCancelamento) {
    return 'agendamentoConfirmaCancelamento'
  }

  if (item.acoes.confirmarData) {
    return 'confirmarData'
  }

  if (item.acoes.alterarData) {
    return 'alterarData'
  }

  return 'visualizar'
}

const verifyEtapaSuprimentos = (item: any) => [
  'aguardandosuprimentos',
  'emcotacao',
  'orcamentoparticularavulsoemcotacao',
  'orcamentoparticularavulsoaguardandosuprimentos',
  'incompleta',
  'liberadosuprimentos',
  'pendentereservadematerial',
  'retornodecotacao',
  'pendenciaaberta',
  'pendenciarespondida',
  'pendente',
  // Para listagem de solicitações que já estão em autorização...
  'analisepreautorizacao',
  'analiseposcotacao',
  'aguardandooperadora',
].includes(item.situacao.key.toLowerCase()) && item.etapa.key.toLowerCase() === 'autorizacao'

const verifyEtapaAutorizacao = (item: any) => [
  'analisepreautorizacao',
  'analisepreautorizacaourgencia',
  'aguardandoautorizacaourgencia',
  'analiseprecotacao',
  'analiseposcotacao',
  'aguardandonegociacaoparticular',
  'aguardandointegracaooperadora',
  'errointegracaooperadora',
  'criticaoperadora',
  'incompleta',
  'pendentedeenviorobodeautorizacao',
  'pendentederetornodautorizacao',
  'emcotacao',
  'aguardandosuprimentos',
  'pendente',
  'pendenciarespondida',
  'retornodecotacao',
  'aguardandooperadora',
  'retornodaautorizacaodohis',
  'respostadorobodeautorizacao',
  'autorizadaparcial',
  'autorizacaopos',
  'autorizada',
  'contestacaomedica',
  'contestacaopendente',
  'revisaocirurgicaautorizacao',
].includes(item.situacao.key.toLowerCase()) && item.etapa.key.toLowerCase() === 'autorizacao'

const verifyEtapaOrcamento = (item: any) => [
  'aguardandoorcamento',
  'novoorcamentoparticular',
  'aguardandoaprovacaoorcamento',
  'aguardandoorcamentoparticularavulso',
  'orcamentoparticularavulsoenviado',
  'orcamentoaprovado',
  'orcamentorecusado',
  'aguardandogeracaodacobranca',
  'aguardandopagamento',
  'orcamentocancelado',
  'pendente',
  'pendenciarespondida',
].includes(item.situacao.key.toLowerCase()) && item.etapa.key.toLowerCase() === 'orcamento'

const verifyEtapaAgenciaTransfusional = (item: any) => [
  'contatopendente',
  'aguardandopaciente',
  'coletarealizada',
  'testependente',
  'reservaconfirmada',
].includes(item.statusAgenciaTransfusional.key.toLowerCase())


const lembreteColor = (lembrete: LembreteEnum) => {
  switch (lembrete) {
    case LembreteEnum.Normal:
      return 'green'

    case LembreteEnum.Alerta:
      return 'yellow'

    case LembreteEnum.Critico:
      return 'red'

    default:
      return ''
  }
}

const isMobile = () => /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const getOrientation = (): string => {
  // @ts-ignore
  const orientation = (window.screen.orientation || {}).type || window.screen.mozOrientation || window.screen.msOrientation
  return orientation
}

const maskCPFCNPJ = (v: string) => {
  if (['', null, undefined].includes(v) || ![11, 14].includes(v.length)) return '-'
  if (v.length === 14) return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5, 8)}/${v.substring(8, 12)}-${v.substring(12, 14)}`
  return `${v.substring(0, 3)}.${v.substring(3, 6)}.${v.substring(6, 9)}-${v.substring(9, 11)}`
}

const clearCPF = (v: string) => {
  if (['', null, undefined].includes(v) || ![11, 14].includes(v.length)) return ''
  if (v.length === 14) return v.replaceAll('.', '').replaceAll('-', '')
  return v
}

const clearReservaDeSangue = (obj: any, val: boolean) => {
  const rs: any = {}

  Object.entries(obj).forEach(([key, value]) => {
    if (/^rs/i.test(key)) rs[key] = value
  })

  Object.entries(rs).forEach(([key, value]) => {
    Object.entries(rs[key]).forEach(([k, v]) => {
      if (['habilitado', 'obrigatorio'].includes(k)) rs[key][k] = val

      if (k === 'rules') rs[key][k] = []

      if (k === 'campos') {
        const { campos } = rs[key]
        Object.entries(campos).forEach((o: any) => { campos[o[0]] = val })
      }
    })
  })

  return rs
}

const clearEmptyFields = (p: any) => {
  const c = p
  Object.entries(c).forEach(([key, value]) => {
    switch (key) {
      case 'paciente':
        Object.entries(c.paciente).forEach(([key1, value1]) => {
          switch (key1) {
            case 'recemNascido':
              if (value !== true && value !== false) {
                delete c[key1]
              }
              break

            case 'categoriaCoberturaVigente':
              if (value !== true && value !== false) {
                delete c[key1]
              }
              break

            case 'alergiaLatex':
              if (value1 !== true && value1 !== false) {
                delete c.paciente[key1]
              }
              break

            default:
              if (!value1) {
                delete c.paciente[key1]
              }
              break
          }
        })
        break
      case 'ultimaTransfusao':
        if (value) {
          const v: any = value
          c[key] = moment(v, 'YYYY-MM').format('YYYY-MM-DD')
        } else {
          delete c[key]
        }
        break

      case 'tempoDeDoenca':
        if ([
          c.tempoDeDoenca.anos,
          c.tempoDeDoenca.meses,
          c.tempoDeDoenca.dias].every((e: any) => [0, null, undefined, ''].includes(e))) {
          delete c[key]
          break
        }
        if (c.tempoDeDoenca.dias === '') c.tempoDeDoenca.dias = 0
        if (c.tempoDeDoenca.meses === '') c.tempoDeDoenca.meses = 0
        if (c.tempoDeDoenca.anos === '') c.tempoDeDoenca.anos = 0
        break

      case 'solicitacaoMedicoConvidado':
        if (!['Sim', 'Nao'].includes(c.solicitacaoMedicoConvidado.medicoConvidado)) delete c[key]
        break

      case 'dadosGestacionais':
        if (!value || typeof value !== 'object') {
          delete c[key]
          break
        }

        if (['', null, undefined].includes(c.dadosGestacionais.idadeGestacional)) {
          delete c.dadosGestacionais.idadeGestacional
        }

        if (![true, false].includes(c.dadosGestacionais.gemelar)) {
          delete c.dadosGestacionais.gemelar
        }

        if (Object.keys(c.dadosGestacionais).length === 0) {
          delete c[key]
        }
        break

      case 'temReservaHemocomponentesSimples':
      case 'temMedicamentosEspeciais':
      case 'temMedicacaoContinua':
      case 'temEquipeMedica':
      case 'temOpmeDoConsultorio':
      case 'temInstrumentadorExterno':
      case 'temInternacaoDeVespera':
      case 'temPrevisaoUsoQuimioterapico':
      case 'temSolicitacaoReservaDeSangue':
      case 'reacaoTransfusional':
      case 'gestacaoPrevia':
      case 'abortoPrevio':
      case 'marcapasso':
      case 'testeCovid':
      case 'reoperacao':
      case 'pacienteB24Positivo':
      case 'pacienteEhTestemunhaDeJeova':
      case 'pacienteEhDiabetico':
      case 'pacienteTransplantado':
      case 'pacienteEhOncologico':
        if (value !== true && value !== false) {
          delete c[key]
        }
        break
      case 'rgh':
        delete c[key]
        break
      case 'pacienteEstaInternado':
        if (value !== true && value !== false) {
          delete c[key]
        }
        break
      case 'alergiaContraste':
        if (value !== true && value !== false) {
          delete c[key]
        }
        break
      case 'solicitacaoProcedimentoInternacao':
        if (!c[key].procedimentoInternacaoId) {
          delete c[key]
        }
        break
      default:
        if (!value) {
          delete c[key]
        }
        break
    }
  })

  return c
}

const displayLateralidade = (display) => {
  switch (display) {
    case 'Esquerdo':
      return 'Esquerdo'
    case 'Direito':
      return 'Direito'
    case 'Bilateral':
      return 'Bilateral'
    case 'NaoAplica':
      return 'Não Aplica'

    default:
      return ''
  }
}

const truncateText = (sentence: string, limit: number) => `${sentence.slice(0, limit)}${sentence.length > limit ? '...' : ''}`

const gradeMedicaEventoColor = (type: string): string => {
  switch (type) {
    case TipoGradeHorarioEnum.ReservadoParaOMedico:
      return '#4aa967'
    case TipoGradeHorarioEnum.PrecisaDeConfirmacaoDoAgendamento:
      return '#6d7277'
    case TipoGradeHorarioEnum.UtilizadoPeloMedico:
      return '#1f6bca'
    default:
      return '#3a4148'
  }
}

const convertToGradeMedicaEvento = (obj: any): GradeMedicaEvento => ({
  id: nanoid(),
  title: TipoGradeHorarioEnum[obj.tipo],
  start: obj.inicio,
  end: obj.fim,
  backgroundColor: gradeMedicaEventoColor(TipoGradeHorarioEnum[obj.tipo]),
})

const setOPMEsToSave = (opmes: any[]) => {
  if (!opmes || opmes.length === 0) return []
  return opmes.map((opme: any) => {
    const op = {
      opmeId: opme.opme ? opme.opme.id : '',
      quantidade: opme.quantidade || 0,
      gradeCompleta: opme.possuiGrade || false,
      fornecedor1Id: opme.fornecedor1Id || null,
      fornecedor2Id: opme.fornecedor2Id || null,
      fornecedor3Id: opme.fornecedor3Id || null,
      observacao: opme.observacao || null,
    }
    return op
  })
}

const isEqual = (value, other) => {
  const type = Object.prototype.toString.call(value)
  if (type !== Object.prototype.toString.call(other)) return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

  const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length
  const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  // eslint-disable-next-line
  const compare = (item1, item2) => {
    const itemType = Object.prototype.toString.call(item1)
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false
    } else {
      if (itemType !== Object.prototype.toString.call(item2)) return false
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false
      } else {
        // eslint-disable-next-line
        if (item1 !== item2) return false
      }
    }
  }

  if (type === '[object Array]') {
    for (let i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    // eslint-disable-next-line
    for (var key in value) {
      // eslint-disable-next-line
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false
      }
    }
  }

  return true
}

const isEmpty = (elem: any) => ['', null, undefined].includes(elem)

// eslint-disable-next-line
const generateGUID = () => {
  // eslint-disable-next-line
  var e = new Uint16Array(8)
  window.crypto.getRandomValues(e)
  // eslint-disable-next-line
  var guid = function (e) {
    let t: any = {}
    // eslint-disable-next-line
    for (t = e.toString(16); t.length < 4;) t = '0' + t
    return t
  }
  return `${guid(e[0])}${guid(e[1])}-${guid(e[2])}-${guid(e[3])}-${guid(e[4])}-${guid(e[5])}${guid(e[6])}${guid(e[7])}`
}

const getPrimeiraEtapaAgendamento = () => {
  const { roles } = getUser().profile || []
  if (roles.includes('backoffice-agendamento-pre-agendamento')) return 'preAgendamento'
  if (roles.includes('backoffice-agendamento-revisao-cirurgica')) return 'revisaoCirurgica'
  return 'enviado'
}

const getConfigObject = (confObject, savedObject) => {
  const obj = {}
  Object.entries(confObject).forEach(([key]) => {
    obj[key] = (key in savedObject) ? savedObject[key] : confObject[key]
    const confKeys = Object.keys(confObject[key])
    const savedKeys = (key in savedObject) ? Object.keys(savedObject[key]) : []
    if (savedKeys.length > 0) {
      const newKey = confKeys.filter(e => !savedKeys.includes(e))
      newKey.forEach((k: any) => {
        if (!['', null, undefined].includes(k)) obj[key][k] = confObject[key][k]
      })
    }
  })
  return obj
}

const getAgendamentoStatuses = () => [
  // Statuses based in api enum
  { key: 'Incompleta', display: 'Incompleta' },
  { key: 'Enviado', display: 'Enviada' },
  { key: 'Pendente', display: 'Pendência' },
  { key: 'PendenciaRespondida', display: 'Pendência Respondida' },
  { key: 'EmAutorizacao', display: 'Em Análise' },
  { key: 'AnalisePreAutorizazao', display: 'Em Análise' },
  { key: 'AnalisePreCotacao', display: 'Em Análise' },
  { key: 'AnalisePosCotacao', display: 'Em Análise' },
  { key: 'NovaSolicitacaoParticular', display: 'Nova Solicitação Particular' },
  { key: 'NovaSolicitacaoDeOrcamentoParticularAvulso', display: 'Nova Solicitação de Orçamento Avulso' },
  { key: 'PreAgendamento', display: 'Pré-agendamento' },
  { key: 'RevisaoCirurgica', display: 'Revisão Cirúrgica' },
  { key: 'RevisaoCirurgicaAutorizacao', display: 'Revisão Cirúrgica' },
  { key: 'AguardandoOrcamento', display: 'Aguardando Orçamento' },
  { key: 'NovoOrcamentoParticular', display: 'Novo Orçamento Particular' },
  { key: 'AguardandoAprovacaoOrcamento', display: 'Aguardando Aprovação do Orçamento' },
  { key: 'OrcamentoAprovado', display: 'Orçamento Aprovado' },
  { key: 'OrcamentoRecusado', display: 'Orçamento Recusado' },
  { key: 'AguardandoGeracaoDaCobranca', display: 'Aguardando Geração da Cobrança' },
  { key: 'AguardandoPagamento', display: 'Aguardando Pagamento' },
  { key: 'OrcamentoCancelado', display: 'Orçamento Cancelado' },
  { key: 'AutorizacaoPos', display: 'Autorização Pós' },
  { key: 'AguardandoOperadora', display: 'Aguardando Autorização' },
  { key: 'EmCotacao', display: 'Aguardando Cotação' },
  { key: 'AguardandoSuprimentos', display: 'Aguardando Suprimentos' },
  { key: 'LiberadoSuprimentos', display: 'Liberado Suprimentos' },
  { key: 'RetornoDeCotacao', display: 'Retorno de Cotação' },
  { key: 'Autorizada', display: 'Autorizada' },
  { key: 'AutorizadaParcial', display: 'Autorizada Parcial' },
  // { key: 'AutorizadaAceitaMedico', display: 'Autorizada - Aceite Médico' },
  { key: 'Cancelada', display: 'Cancelada' },
  { key: 'CancelamentoSolicitado', display: 'Cancelada' },
  { key: 'ContestacaoMedica', display: 'Contestação Médica' },
  { key: 'ContestacaoPendente', display: 'Contestação Pendente' },
  { key: 'PendenciaEncerrada', display: 'Pendência Encerrada' },
  { key: 'AguardandoIntegracaoOperadora', display: 'Aguardando Integração Operadora' },
  { key: 'ErroIntegracaoOperadora', display: 'Erro de Integração Operadora' },
  { key: 'CriticaOperadora', display: 'Crítica Operadora' },
] as { key: string, display: string }[]

const displayRoboAutorizacao = (status: string) => ({
  AUTORIZADO: { key: 'AUTORIZADO', text: 'Autorizado', class: 'green darken-2', color: '#2E7D32' },
  NAO_NECESSITA_AUTORIZACAO: { key: 'NAO_NECESSITA_AUTORIZACAO', text: 'Não necessita autorização', class: 'green darken-2', color: '#2E7D32' },
  AUTORIZACAO_POR_EMAIL: { key: 'AUTORIZACAO_POR_EMAIL', text: 'Autorização por e-mail', class: 'blue darken-2', color: '#2E7D32' },
  CANCELADO: { key: 'CANCELADO', text: 'Cancelado', class: 'red darken-2', color: '#B71C1C' },
  NEGADO: { key: 'NEGADO', text: 'Negado', class: 'red darken-2', color: '#B71C1C' },
  PORTAL_INDISPONIVEL: { key: 'PORTAL_INDISPONIVEL', text: 'Portal indisponível', class: 'red darken-2', color: '#B71C1C' },
  FALHA_AUTORIZACAO: { key: 'FALHA_AUTORIZACAO', text: 'Falha na autorização', class: 'red darken-2', color: '#B71C1C' },
  FALHA: { key: 'FALHA', text: 'Falha na autorização', class: 'red darken-2', color: '#B71C1C' },
  ANEXO_INVALIDO: { key: 'ANEXO_INVALIDO', text: 'Anexo inválido', class: 'red darken-2', color: '#B71C1C' },
  RETORNO_VAZIO: { key: 'RETORNO_VAZIO', text: 'Robô de autorização não retornou os dados de resposta do pedido de autorização', class: 'red darken-2', color: '#B71C1C' },
  PENDENCIAS: { key: 'PENDENCIAS', text: 'Pendências', class: 'pink darken-2', color: '#FBC02D' },
  DESCONHECIDO: { key: 'DESCONHECIDO', text: 'Desconhecido', class: 'grey darken-2', color: '#1565C0' },
  EM_ANALISE: { key: 'EM_ANALISE', text: 'Em Análise', class: 'blue darken-2', color: '#1565C0' },
})[status]

const formatProcedimentosUpdateSolicitacao = (obj: any[]) => {
  const procedimentos = obj.map((e: any) => ({
    procedimentoId: e.id,
    procedimentoPrincipal: e.procedimentoPrincipal,
    quantidade: e.quantidade,
    lateralidade: e.lateralidade.key,
    coberturaVigente: e.coberturaVigente,
    particular: e.particular,
  }))
  return procedimentos
}

const getProcedimentoIdFromProcedimentos = (procedimentoPrincipal: any, procedimentosAssociados: any = []) => {
  const procedimentosIds: string[] = []
  if (![null, undefined].includes(procedimentoPrincipal)) {
    if (procedimentoPrincipal.id) procedimentosIds.push(procedimentoPrincipal.id)
  }

  procedimentosAssociados.forEach((procedimento: any) => {
    if (procedimento && procedimento.id) procedimentosIds.push(procedimento.id)
  })

  return procedimentosIds
}

const bytesToMegabytes = (bytes: number) => bytes / 1000000

const toHttpParams = (obj?: object): string => {
  if (obj) {
    const paramsArray: string[] = []

    Object.keys(obj).forEach((key) => {
      // eslint-disable-next-line
      if (obj[key] !== undefined) {
        if (Array.isArray(obj[key])) {
          obj[key].forEach((elem: string | number, index: number) => {
            paramsArray.push(`${key}[${index}]=${elem}`)
          })
        } else {
          paramsArray.push(`${key}=${obj[key]}`)
        }
      }
    })

    return paramsArray.join('&')
  }

  return ''
}

const getUfs = () => [
  { id: 'AC', value: 'AC' },
  { id: 'AL', value: 'AL' },
  { id: 'AP', value: 'AP' },
  { id: 'AM', value: 'AM' },
  { id: 'BA', value: 'BA' },
  { id: 'CE', value: 'CE' },
  { id: 'DF', value: 'DF' },
  { id: 'ES', value: 'ES' },
  { id: 'GO', value: 'GO' },
  { id: 'MA', value: 'MA' },
  { id: 'MT', value: 'MT' },
  { id: 'MS', value: 'MS' },
  { id: 'MG', value: 'MG' },
  { id: 'PA', value: 'PA' },
  { id: 'PB', value: 'PB' },
  { id: 'PR', value: 'PR' },
  { id: 'PE', value: 'PE' },
  { id: 'PI', value: 'PI' },
  { id: 'RJ', value: 'RJ' },
  { id: 'RN', value: 'RN' },
  { id: 'RS', value: 'RS' },
  { id: 'RO', value: 'RO' },
  { id: 'RR', value: 'RR' },
  { id: 'SC', value: 'SC' },
  { id: 'SP', value: 'SP' },
  { id: 'SE', value: 'SE' },
  { id: 'TO', value: 'TO' },
]

const isNull = (element: any) => ['', null, undefined].includes(element)

const getColorFromReservaSala = (tipoReservaSala: TipoReservaSalaEnum, doctorInfo) => {
  const { isDoctor, isLoggedinDoctor } = doctorInfo

  if (isDoctor) {
    if (isLoggedinDoctor) {
      return '#FFFF00'
    }

    return '#1565C0'
  }

  switch (tipoReservaSala) {
    case 'AgendamentoApenasNoHis':
      return '#388E3C'
    case 'PreparoDeSala':
      return '#D50000'
    case 'PreAgendamento':
      return '#F57C00'
    case 'Cirurgia':
      return '#1565C0'
    case 'ReservaPreferencial':
      return '#e6de4e'
    case 'ReservaDeBloqueio':
      return '#A8422D'
    default:
      return ''
  }
}

const flatPhone = (phoneNumber: string) => phoneNumber.replaceAll(/\D/ig, '')

const setMateriaisCotadosOpme = (grupo: any, enumType?: GrupoOpmeTipoEnum) => {
  if (grupo && grupo.length === 0) return []

  const mappedGroup: any[] = []

  grupo.filter((e: any) => (enumType ? e.tipo === enumType : true)).forEach((items: any) => {
    items.opmes.forEach((opme: any) => {
      // eslint-disable-next-line no-param-reassign
      opme.quantidadeAutorizada = opme.quantidadeAutorizada || 0
      mappedGroup.push(opme)
    })
  })

  const orderByFornecedor = (grp: any[]) => {
    const onlyUnique = (value: any, index: number, self: any) => self.indexOf(value) === index
    const group: any[] = []
    let fornecedorIdGroup: any[] = []

    grp.forEach((item: any) => fornecedorIdGroup.push(item.fornecedor1Id))

    fornecedorIdGroup = fornecedorIdGroup.filter(onlyUnique)

    fornecedorIdGroup.forEach((fornecedorId: any) => {
      const groupObj = grp.find((e: any) => e.fornecedor1.id === fornecedorId)
      let fornecedorNome = 'Fonecedor não informado'
      let opmes: any[] = []

      if (groupObj) {
        fornecedorNome = groupObj.fornecedor1.nome
        opmes = grp.filter((opme: any) => opme.fornecedor1.id === fornecedorId)
      } else {
        opmes = grp.filter((opme: any) => opme.fornecedor1.id === '00000000-0000-0000-0000-000000000000' || opme.fornecedor1.id === undefined)
      }

      group.push({
        fornecedorId,
        fornecedorNome,
        opmes,
      })
    })

    return group
  }

  return orderByFornecedor(mappedGroup)
}

const getOpmesApagados = (grupoOpmeOriginal: any[], grupoOpmeModificado: any[], solicitacaoId: string) => {
  if (grupoOpmeOriginal.length === 0) return []
  const grupoOpmeIdsOriginais = grupoOpmeOriginal.map((e: any) => e.id)
  const grupoOpmeIdsModificados = grupoOpmeModificado.map((e: any) => e.id)
  const opmesASeremApagados = []
  grupoOpmeIdsOriginais.forEach((idOriginal: string) => {
    if (grupoOpmeIdsModificados.includes(idOriginal)) {
      const opmesOriginais = grupoOpmeOriginal.find((grupo: any) => grupo.id === idOriginal).opmes
      const opmesModificados = grupoOpmeModificado.find((grupo: any) => grupo.id === idOriginal).opmes

      if (opmesOriginais.length > opmesModificados.length) {
        const opmesOriginaisIds = opmesOriginais.map((opme: any) => opme.opmeId)
        const opmesModificadosIds = opmesModificados.map((opme: any) => opme.opmeId)
        opmesOriginaisIds.filter((id: string) => !opmesModificadosIds.includes(id))
          .forEach((id: string) => {
            const payload = { solicitacaoId, grupoOpmeDaSolicitacaoId: idOriginal, opmeId: id }
            // @ts-ignore
            opmesASeremApagados.push(payload)
          })
      }
    }
  })
  return opmesASeremApagados
}

const setValorDoCampoUnico = (campos: any, campoValue: any, defaultValue: any) => {
  if (!['', undefined, null].includes(defaultValue)) return defaultValue

  if (Object.values(campos).filter(v => !!v).length === 1) {
    let valorDoCampo = ''
    Object.entries(campos).forEach(([key, value]) => {
      if (value) valorDoCampo = campoValue[key]
    })
    return valorDoCampo
  }

  return defaultValue
}

function canShowSeloNaoSegueOProtocoloHardCoded(
  data: {
    createdOn: string, convenioId: string, hospitalId: string, medicoId: string, procedimentoNome: string, segueProtocolo: boolean
  },
) {
  // Show selo não segue o protocolo para o hospital vitória anália franco da UHG e convênio amil
  const hospitalId = 'e969d8fa-deb6-478b-a7ec-2e016563d4f6'
  const medicosIds = ['f9937429-1bde-40b3-a7bf-8b878af4a766', '49849840-3e42-4b83-b342-08d866236da7']
  const procedimentoNome = 'gastroplastia para obesidade mórbida por videolaparoscopia'
  const convenioIds = [
    '06645364-60b0-4343-ba94-02b168a534f7',
    '1f143983-a3d7-4d37-86ca-180e59965d9a',
    '2e8d6c05-a8b0-4732-af95-572f11d91d93',
    'efe8829e-c3e3-4b78-8bae-5e747fb4a902',
    'deb53c40-f3e8-4baf-a138-9c36b2c37a79',
    'ebd3d953-dfa4-4ca3-bf81-b63d8350e2c0',
    '1f361c75-1063-4957-8fc1-d57b533ea4ab',
    '45cb86c4-2aa5-4a31-b8fd-ecf1014c4446',
  ]
  const dataDeGoLiveDoProtocolo = new Date('2023-01-31T00:00:00')
  const createdOn = new Date(data.createdOn)

  if (
    !data.hospitalId
    || !data.medicoId
    || !data.procedimentoNome
    || !data.convenioId
    || !data.createdOn
  ) {
    return false
  }

  const solicitacaoConvenioId = data.convenioId || ''

  if (
    !data.segueProtocolo
    && convenioIds.includes(solicitacaoConvenioId.toLowerCase())
    && hospitalId === data.hospitalId.toLowerCase()
    && medicosIds.includes(data.medicoId.toLowerCase())
    && procedimentoNome === data.procedimentoNome.toLowerCase()
    && createdOn.getTime() >= dataDeGoLiveDoProtocolo.getTime()
  ) {
    return true
  }

  return false
}

const contains = (target: any[], elements: any[]) => {
  const includedElements: boolean[] = []
  elements.forEach((element: any) => includedElements.push(target.includes(element)))
  return includedElements.some((e: boolean) => e)
}

const minutesToHours = (value: any) => {
  if (['', 0, undefined, null].includes(value)) return '0'
  const time = parseInt(value, 10)
  const horas = Math.floor(time / 60)
  const minutos = time % 60
  if (horas < 1) return `${minutos} ${minutos < 2 ? 'minuto' : 'minutos'}`
  return minutos < 1 ? `${horas} ${horas < 2 ? 'hora' : 'horas'}` : `${horas} ${horas < 2 ? 'hora' : 'horas'} e ${minutos} ${minutos < 2 ? 'minuto' : 'minutos'}`
}

const getHospitalAreaName = () => {
  /**
   * Regulação e Autorização compartilham o mesmo routeName 'BackofficeAutorizacao'
   * Essa exceção deve ser a primeira a ser validada...
   */
  if (getRoute().path === '/backoffice/regulacao') return 'regulação'
  /**
   * Em seguida, verificamos se o usuário está na rota padrão e retornamos o nome de cada área baseada na view padrão...
   */
  if (getRoute().name === 'default') {
    const defaultRoute = JSON.parse(getUser().profile.pageAuthorized.find((e: any) => /^\{/.test(e)))
    switch (defaultRoute.view) {
      case 'backoffice-agendamento':
        return 'agendamento'
      case 'backoffice-autorizacao':
        return 'autorização'
      case 'backoffice-suprimentos':
        return 'suprimentos'
      case 'backoffice-agencia-transfufional':
        return 'agência transfufional'
      case 'backoffice-orcamento':
        return 'orçamento'
      case 'backoffice-regulacao':
        return 'regulação'
      case 'backoffice-pre-anestesico':
        return 'pré-anestesico'
      case 'backoffice-farmacia':
        return 'farmácia'
      default:
        return 'agendamento'
    }
  }
  /**
   * Retorna o nome da rota por url...
   */
  switch (getRoute().path) {
    case '/backoffice/agendamento':
      return 'agendamento'
    case '/backoffice/autorizacao':
      return 'autorização'
    case '/backoffice/suprimentos':
      return 'suprimentos'
    case '/backoffice/agencia-transfufional':
      return 'agência transfufional'
    case '/backoffice/orcamento':
      return 'orçamento'
    case '/backoffice/regulacao':
      return 'regulação'
    case '/backoffice/fidelizacao':
      return 'fidelização'
    case '/backoffice/pre-anestesico':
      return 'pré-anestesico'
    case '/backoffice/farmacia':
      return 'farmácia'
    default:
      return 'agendamento'
  }
}

const handleEspecialidades = (params: any, cbos: any[]) => {
  const { descricaoEspecialidadePrincipal, cboIds } = params
  if (descricaoEspecialidadePrincipal === '' && cboIds.length === 0) return params
  if (descricaoEspecialidadePrincipal === '' && cboIds.length > 0) {
    const especialidade = cbos.find((cbo: any) => cbo.id === cboIds[0])
    return { ...params, cboIds, descricaoEspecialidadePrincipal: especialidade.descricao }
  }
  if (descricaoEspecialidadePrincipal !== '' && cboIds.length === 0) {
    const cboInList = cbos.find((cbo: any) => cbo.descricao === descricaoEspecialidadePrincipal)
    cboIds[0] = cboInList.id
    return { ...params, cboIds, descricaoEspecialidadePrincipal }
  }

  const cboInList = cbos.find((cbo: any) => cbo.descricao === descricaoEspecialidadePrincipal)
  const cboInCboIds = cboIds.find((id: string) => cboInList.id === id)

  if (!cboInCboIds) {
    cboIds.unshift(cboInList.id)
  } else {
    cboIds.forEach((id: string, index: number) => {
      if (id === cboInList.id) {
        cboIds.splice(index, 1)
        cboIds.unshift(id)
      }
    })
  }

  return { ...params, cboIds, descricaoEspecialidadePrincipal }
}

const parseShiftInfo = (shiftData, roomId) => {
  const shiftsInfo: any = []

  shiftData.forEach((shift) => {
    let id
    if (shift.descricao === 'Manhã') {
      id = `morning/${roomId}`
    } else if (shift.descricao === 'Tarde') {
      id = `afternoon/${roomId}`
    } else if (shift.descricao === 'Noite') {
      id = `night/${roomId}`
    }

    shiftsInfo.push({ id, title: shift.descricao })
  })

  return shiftsInfo
}

const getDateTimeCurrentWeekByWeekdayString = (weekday) => {
  const today = new Date()
  const first = today.getDate() - today.getDay()
  const firstday = new Date(today.setDate(first))
  let currentDate = firstday

  for (let i = 1; i <= 7; i++) {
    if (currentDate.toLocaleString('en-us', { weekday: 'long' }) === weekday) {
      return currentDate
    }

    currentDate = new Date(currentDate)
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return null
}

const opcaoHabilitadoShared = (template: any, prop1: string, prop2: string) => {
  if ('formulario' in template) {
    if (template.formulario[prop1] === undefined) return false
    if (template.formulario[prop1].campos === undefined) return false
    return template.formulario[prop1].campos[prop2]
  }
  return false
}

const campoHabilitadoShared = (template: any, prop: string) => {
  if ('formulario' in template) {
    if (template.formulario[prop] === undefined) return false
    return !!template.formulario[prop].habilitado
  }
  return false
}

const getSingleDate = () => new Intl.DateTimeFormat('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'America/Sao_Paulo' }).format(Date.now())

const classByTipoReservaSala = (tipoReservaSala: string) => {
  switch (tipoReservaSala) {
    case TipoReservaSalaEnum.AgendamentoApenasNoHis:
      return 'finx-calendar__event--agendamento-apenas-no-his'
    case TipoReservaSalaEnum.PreAgendamento:
      return 'finx-calendar__event--pre-agendamento'
    case TipoReservaSalaEnum.Cirurgia:
      return 'finx-calendar__event--cirurgia-autorizada'
    case TipoReservaSalaEnum.DataVirtual:
      return 'finx-calendar__event--data-virtual'
    case TipoReservaSalaEnum.CirurgiaNaoAutorizada:
      return 'finx-calendar__event--cirurgia-nao-autorizada'
    case TipoReservaSalaEnum.ReservaDeBloqueio:
      return 'finx-calendar__event--reserva-bloqueio'
    case TipoReservaSalaEnum.ReservaPreferencial:
      return 'finx-calendar__event--reserva-preferencial'
    default:
      return ''
  }
}

const classByComplexidadeReservaSala = (tipoReservaSala: string) => {
  switch (tipoReservaSala) {
    case ComplexidadeEnum.baixa:
      return 'finx-calendar__event--cirurgia-baixa-complexidade'
    case ComplexidadeEnum.media:
      return 'finx-calendar__event--cirurgia-media-complexidade'
    case ComplexidadeEnum.alta:
      return 'finx-calendar__event--cirurgia-alta-complexidade'
    default:
      return ''
  }
}

const tipoReservaDeSalaMap = new Map<string, string>([
  ['Cirurgia', '#1565C0'],
  ['PreAgendamento', '#EF6C00'],
  ['AgendamentoApenasNoHis', '#388E3C'],
  ['DataVirtual', '#707070'],
  ['PreparoDeSala', '#D50000'],
  ['CirurgiaNaoAutorizada', '#F9A825'],
])

export const convertH2M = (timestamp: string) => {
  if (!timestamp) return 0
  return new Date(timestamp).getTime() / 1000 / 60
}

const createLinearGradientByTimeDifference = (start: string, end: string, prepTime: number, reservaSala: string) => {
  if (!start || !end || !prepTime || !reservaSala) return ''
  const difference = convertH2M(end) - convertH2M(start)
  const secondaryColor = 100 / ((difference + prepTime) / prepTime)
  const primaryColor = 100 - secondaryColor

  if (!['AgendamentoApenasNoHis'].includes(reservaSala)) {
    return `linear-gradient(to right, ${tipoReservaDeSalaMap.get(reservaSala)} ${primaryColor}%, ${tipoReservaDeSalaMap.get('PreparoDeSala')} ${secondaryColor}%, ${tipoReservaDeSalaMap.get('PreparoDeSala')} ${secondaryColor}%)`
  }

  return ''
}

const handleCalendarResources = (payload: any) => {
  let resources: any[] = []
  if ('centrosCirurgicos' in payload) {
    // eslint-disable-next-line
    resources = payload.centrosCirurgicos.map((c: any) => {
      if (!c.salas || c.salas.length === 0) {
        return [{
          id: `placeholder-${c.id}`,
          title: ' ',
          centroCirurgicoId: (c && c.id) ? c.id : undefined,
          centroCirurgicoNome: (c && c.nome) ? c.nome : undefined,
          salaCirurgicaNome: 'Placeholder',
        }]
      }
      return c.salas.map((s: any) => {
        const novaSala = {
          id: s.id,
          title: s.nome,
          centroCirurgicoId: (c && c.id) ? c.id : undefined,
          centroCirurgicoNome: (c && c.nome) ? c.nome : undefined,
          salaCirurgicaId: s.id,
          salaCirurgicaHisId: s.salaCirurgicaHisId,
          salaCirurgicaNome: s.nome,
          horaFim: s.horaFim,
          horaInicio: s.horaInicio,
          tempoDePreparacao: s.tempoDePreparacao,
        }

        Object.entries(novaSala).forEach(([key, value]) => {
          if (['', null, undefined].includes(value as any)) delete novaSala[key]
        })

        return novaSala
      })
    })
  }

  if (resources.length === 0) return []

  const sortedResources = resources.sort((a, b) => {
    const nomeA = a[0].centroCirurgicoNome
    const nomeB = b[0].centroCirurgicoNome
    if (nomeA < nomeB) {
      return -1
    }
    if (nomeA > nomeB) {
      return 1
    }
    return 0
  })

  const lastItemSortedResources = sortedResources[sortedResources.length - 1][0]
  sortedResources[sortedResources.length - 1].push({
    id: 'default',
    title: ' ',
    salaCirurgicaNome: 'Z9-default',
    centroCirurgicoNome: lastItemSortedResources.centroCirurgicoNome,
    centroCirurgicoId: lastItemSortedResources.centroCirurgicoId,
  })

  return sortedResources.flat()
}

const handleCalendarEvents = (payload: any, hospitalId: string = '') => {
  let events = []
  if ('centrosCirurgicos' in payload) {
    // eslint-disable-next-line
    events = payload.centrosCirurgicos.map((c: any) => {
      if (!c.salas || c.salas.length === 0) return []
      return c.salas.map((s: any) => {
        if (!s.reservas || s.reservas.length === 0) return []
        const novasReservas = s.reservas.map((r: any) => {
          const novaReserva = {
            id: r.solicitacaoId,
            resourceId: s.id,
            solicitacaoId: r.solicitacaoId,
            hospitalId,
            salaCirurgicaId: s.id,
            salaCirurgicaNome: s.nome,
            centroCirurgicoId: (c && c.id) ? c.id : undefined,
            centroCirurgicoNome: (c && c.nome) ? c.nome : undefined,
            tempoDePreparacao: s.tempoDePreparacao,
            tempoPreparacaoSalaCirurgica: r.tempoPreparacaoSalaCirurgica,
            dataAgendamentoVirtual: r.dataAgendamentoVirtual,
            numeroAgendamento: r.numeroAgendamento,
            ehObrigatorioAtenderARegra: r.ehObrigatorioAtenderARegra,
            tipoReservaSala: r.tipoReservaSala,
            solicitacaoStatusSituacao: r.solicitacaoStatusSituacao,
            complexidade: r.complexidade,
            start: r.inicio,
            end: r.fim,
            gradient: createLinearGradientByTimeDifference(r.inicio, r.fim, r.tempoPreparacaoSalaCirurgica, r.tipoReservaSala),
            medicoNome: r.medicoNome,
            title: TipoReservaSalaEnum.AgendamentoApenasNoHis === r.tipoReservaSala ? '&nbsp;' : r.medicoNome,
            editable: ![
              TipoReservaSalaEnum.AgendamentoApenasNoHis,
              TipoReservaSalaEnum.PreAgendamento,
              TipoReservaSalaEnum.ReservaDeBloqueio,
              TipoReservaSalaEnum.ReservaPreferencial,
            ].includes(r.tipoReservaSala),
            durationEditable: false,
            resourceEditable: ![
              TipoReservaSalaEnum.AgendamentoApenasNoHis,
              TipoReservaSalaEnum.PreAgendamento,
              TipoReservaSalaEnum.ReservaDeBloqueio,
              TipoReservaSalaEnum.ReservaPreferencial,
            ].includes(r.tipoReservaSala),
            pacienteNome: r.pacienteNome,
            convenioNome: r.convenioNome,
            procedimentoPrincipalCodigo: r.procedimentoPrincipalCodigo,
            procedimentoPrincipalDescricao: r.procedimentoPrincipalDescricao,
            borderColor: '#ffffffb3',
            classNames: [classByTipoReservaSala(r.tipoReservaSala)],
          }

          Object.entries(novaReserva).forEach(([key, value]) => {
            if (['', null, undefined].includes(value as any)) delete novaReserva[key]
          })

          return novaReserva
        })
        return novasReservas
      })
    })
  }
  return events.flat(2)
}

export const caraterCirurgiaMap = new Map<string, string>([
  ['EletivoAutorizacao', 'Eletivo'],
  ['Urgencia', 'Urgência'],
  ['EletivoSemAutorizacao', 'Emergência'],
  ['Emergencia', 'Emergência'],
])

export const solicitacaoStatusSituacaoMap = new Map<string, string>([
  ['PreAgendamento', 'Pré-agendamento'],
  ['RevisaoCirurgica', 'Revisão cirúrgica'],
  ['RevisaoCirurgicaAutorizacao', 'Revisão cirúrgica'],
  ['Divergente', 'Divergente'],
  ['Provisionada', 'Provisionada'],
  ['ValidacaoPendente', 'Validação pendente'],
  ['Validada', 'Validada'],
  ['Paga', 'Paga'],
  ['EnviadoParaPagamento', 'Enviado para pagamento'],
  ['Incompleta', 'Incompleta'],
  ['EmAnalise', 'Em análise'],
  ['Pendente', 'Pendente'],
  ['Autorizada', 'Autorizada'],
  ['Negada', 'Negada'],
  ['Agendada', 'Agendada'],
  ['EmCancelamento', 'Em cancelamento'],
  ['Cancelada', 'Cancelada'],
  ['Enviado', 'Enviado'],
  ['EmTriagem', 'Em triagem'],
  ['AlteracaoDeCarater', 'Alteração de caráter'],
  ['EmCotacao', 'Em cotação'],
  ['OrcamentoParticularAvulsoEmCotacao', 'Orcamento particular avulso em Cotação'],
  ['EmAutorizacao', 'Em autorização'],
  ['AnalisePreAutorizacao', 'Análise pré-autorização'],
  ['AnalisePreCotacao', 'Análise pré-cotação'],
  ['AnalisePosCotacao', 'Análise pós-cotação'],
  ['PendenteDeEnvioRoboDeAutorizacao', 'Pendente de envio pelo robô de autorização'],
  ['RetornoDeCotacao', 'Retorno de cotação'],
  ['AguardandoOperadora', 'Aguardando autorização'],
  ['AguardandoIntegracaoOperadora', 'Aguardando integração operadora'],
  ['ErroIntegracaoOperadora', 'Erro de integração operadora'],
  ['CriticaOperadora', 'Crítica Operadora'],
  ['RespostaDoRoboDeAutorizacao', 'Resposta do robô de autorização'],
  ['CancelamentoSolicitado', 'Cancelamento solicitado'],
  ['PendenciaRespondida', 'Pendência respondida'],
  ['ContestacaoMedica', 'Contestação médica'],
  ['ContestacaoPendente', 'Contestação pendente'],
  ['Contato', 'Contato'],
  ['NovaDataSolicitada', 'Nova data solicitada'],
  ['AutorizadaParcial', 'Autorizada parcial'],
  ['AceitaPeloMedico', 'Aceita pelo médico'],
  ['AutorizacaoPos', 'Autorização pós'],
  ['AguardandoSuprimentos', 'Aguardando suprimentos'],
  ['AguardandoOrcamento', 'Aguardando orçamento'],
  ['NovoOrcamentoParticular', 'Novo orçamento particular'],
  ['AguardandoAprovacaoOrcamento', 'Aguardando aprovação orçamento'],
  ['AguardandoOrcamentoParticularAvulso', 'Aguardando orçamento particular avulso'],
  ['NovaSolicitacaoDeOrcamentoParticularAvulso', 'Nova solicitação de orçamento particular avulso'],
  ['OrcamentoParticularAvulsoAguardandoSuprimentos', 'Orçamento particular avulso aguardando suprimentos'],
  ['OrcamentoParticularAvulsoEnviado', 'Orçamento particular avulso enviado'],
  ['OrcamentoAprovado', 'Orçamento aprovado'],
  ['OrcamentoRecusado', 'Orçamento recusado'],
  ['AguardandoGeracaoDaCobranca', 'Aguardando geração da cobrança'],
  ['AguardandoPagamento', 'Aguardando pagamento'],
  ['OrcamentoCancelado', 'Orçamento cancelado'],
  ['LiberadoSuprimentos', 'Liberado suprimentos'],
  ['PendenteReservaDeMaterial', 'Pendente reserva de material'],
  ['NovaSolicitacaoParticular', 'Nova solicitação particular'],
  ['AguardandoReservaHis', 'Aguardando reserva His'],
  ['AguardandoAlteracaoDeReservaHis', 'Aguardando alteração de reserva His'],
  ['ErroReservaHis', 'Erro de reserva His'],
  ['ErroAoAlterarReservaHis', 'Erro ao alterar reserva His'],
  ['PendenciaAdministrativa', 'Pendência administrativa'],
  ['RetornoDaAutorizacaoDoHis', 'Retorno da autorização do His'],
  ['AguardandoAutorizacao', 'Aguardando autorização'],
  ['AutorizacaoNegada', 'Autorização negada'],
  ['Realizada', 'Realizada'],
])

const filtrarItensPorAcao = (items: any[], action: string) => items.filter((item: any) => Boolean(item.acoes[action]))

const getWeekdayByDate = (referenceDate) => {
  const weekday = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
  ]

  if (referenceDate) {
    const date = typeof referenceDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(referenceDate)
      ? moment(referenceDate, 'YYYY-MM-DD', true)
      : moment(referenceDate)

    if (!date.isValid()) return ''

    return weekday[date.day()]
  }

  return ''
}

const replaceRange = (string, startIndex, endIndex, replaceString) => string.substring(0, startIndex) + replaceString + string.substring(endIndex)
const hideEmail = (email) => {
  const atIndex = email.indexOf('@')
  if (atIndex <= 0) return email

  const localPart = email.slice(0, atIndex)
  const domainPart = email.slice(atIndex)

  if (localPart.length <= 1) {
    return `*${domainPart}`
  }

  if (localPart.length <= 5) {
    return localPart[0] + 'X'.repeat(localPart.length - 1) + domainPart
  }

  const visiblePart = localPart.slice(0, localPart.length - 5)
  const hiddenPart = 'X'.repeat(5)

  return visiblePart + hiddenPart + domainPart
}

const allowOnlyNumbersThatDoNotStartWithZero = (input, value) => {
  const inputValue = value.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
  const char = input.key

  if ((inputValue.length === 0 && char === '0')) {
    input.preventDefault()
  }

  if (!/^[0-9]$/.test(char)
      && !(input.key === 'Backspace'
      || input.key === 'Delete'
      || input.key === 'ArrowRight'
      || input.key === 'ArrowLeft')) {
    input.preventDefault()
  }
}

const allowOnlyNumbersBetweenRange = (event, startRange, endRange) => {
  const min = startRange
  const max = endRange
  const input = event.target
  const { key } = event
  const { value } = input
  if (
    key === 'Backspace'
    || key === 'Delete'
    || key === 'ArrowLeft'
    || key === 'ArrowRight'
    || key === 'Tab'
  ) {
    return
  }
  if (!/^[0-9]$/.test(key)) {
    input.value = value.slice(0, -1)
    return
  }
  const number = parseInt(value, 10)
  if (number < min || number > max) {
    input.value = value.slice(0, -1)
  }
}

const dateRangeOverlap = (
  firstDateRangeStart,
  firstDateRangeEnd,
  secondDateRangeStart,
  secondDateRangeEnd,
) => {
  if (firstDateRangeStart === secondDateRangeStart) {
    return true
  }

  if (secondDateRangeStart > firstDateRangeStart && secondDateRangeEnd < firstDateRangeEnd) {
    return true
  }
  // eslint-disable-next-line no-mixed-operators
  return firstDateRangeStart > secondDateRangeStart && firstDateRangeStart < secondDateRangeEnd || secondDateRangeStart > firstDateRangeStart && secondDateRangeStart < firstDateRangeEnd
}

const formatStatusSituacaoFarmacia = (value: string) => {
  switch (value) {
    case 'PendenteReserva':
      return 'Pendente de reserva'
    case 'PendenteAjusteData':
      return 'Pendente de ajuste de data'
    case 'PendenteAjusteMaterial':
      return 'Pendente de ajuste de material'
    case 'PendenteCancelamento':
      return 'Pendente de cancelamento'
    case 'Concluido':
      return 'Concluído'
    default:
      return ''
  }
}

const base64toBlob = (base64Data: string) => {
  const sliceSize = 1024
  const byteCharacters = atob(base64Data)
  const bytesLength = byteCharacters.length
  const slicesCount = Math.ceil(bytesLength / sliceSize)
  const byteArrays = new Array(slicesCount)

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize
    const end = Math.min(begin + sliceSize, bytesLength)

    const bytes = new Array(end - begin)
    // eslint-disable-next-line
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0)
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes)
  }
  return new Blob(byteArrays, { type: 'application/pdf' })
}

const cpfOuStringComum = (str: string) => {
  const pattern: boolean = /\d{3}\.\d{3}\.\d{3}-\d{2}/.test(str)
  return pattern ? str.replace(/\D/ig, '') : str
}

const maskPhoneNumber = (input: string | null) => {
  if (!input) return input

  // Identificar os números na string
  const digits = input.replace(/\D/g, '')

  // Se houver apenas um número, não o substituímos
  if (digits.length <= 1) return input

  // Calcular quantos números devem ser mascarados
  const maskCount = Math.floor(digits.length / 2)

  // Construir a versão mascarada
  const maskedDigits = digits[0] + digits[1] + 'X'.repeat(maskCount) + digits.slice(maskCount + 1)

  // Substituir os números originais pelos mascarados mantendo os caracteres não numéricos
  let digitIndex = 0;
  let result = "";

  for (const char of input) {
    if (/\d/.test(char)) {
      result += maskedDigits[digitIndex];
      digitIndex += 1;
    } else {
      result += char;
    }
  }

  return result;
}

const formatAnonymizedPhoneNumber = (input: string): string => {
  if (!input || typeof input !== 'string') return input

  const len = input.length

  if (len === 0) return input
  if (len === 1) return `(${input}`
  if (len === 2) return `(${input})`

  const ddd = input.slice(0, 2)
  const phoneDigits = input.slice(2)
  const phoneLen = phoneDigits.length

  if (phoneLen === 0) return `(${ddd})`

  const prefix = `(${ddd}) `

  // 9+ dígitos no telefone = celular → formato 5+4
  if (phoneLen >= 9) {
    return `${prefix}${phoneDigits.slice(0, 5)}-${phoneDigits.slice(5)}`
  }

  // 5-8 dígitos → formato 4+resto (fixo ou incompleto)
  if (phoneLen > 4) {
    return `${prefix}${phoneDigits.slice(0, 4)}-${phoneDigits.slice(4)}`
  }

  // <= 4 dígitos → sem traço
  return `${prefix}${phoneDigits}`
}

const formatHemocomponenteName = (value: string = '') => {
  switch (value.toUpperCase()) {
    case 'CONCENTRADOHEMACIAS':
      return 'concentradoHemacias'
    case 'CONCENTRADOPLAQUETAS':
      return 'concentradoPlaquetas'
    case 'CRIOPRECIPITADO':
      return 'crioprecipitado'
    case 'PLASMAFRESCOCONGELADO':
      return 'plasmaFrescoCongelado'
    case 'TIPAGEMSANGUINEAABORHPAI':
      return 'tipagemSanguineaABORHPAI'
    case 'TIPAGEMSANGUINEA':
      return 'tipagemSanguinea'
    case 'SEMRESERVA':
      return 'semReserva'
    default:
      return ''
  }
}

const blobToFile = (blob: Blob, fileName:string, fileType: string): File => new File([blob], fileName, {
  lastModified: Date.now(),
  type: fileType,
})

const createPDFWithMultiplePagesGeneration = async (
  fileName: string,
  htmlTemplateRef: any,
  pageOrientation: 'portrait' | 'landscape' = 'portrait',
) => {
  const tempContainer = document.createElement('div')
  tempContainer.style.position = 'absolute'
  tempContainer.style.top = '-9999px'
  tempContainer.style.left = '-9999px'

  document.body.appendChild(tempContainer)

  htmlTemplateRef.$el.style.display = 'block'
  tempContainer.appendChild(htmlTemplateRef.$el)

  const TissContent = htmlTemplateRef.$el

  const PDFBlob = await pdfService.generateFromHtmlWithMultiplePages(TissContent, {
    orientation: pageOrientation,
    fileName,
    margin: 10,
    uploadFile: true,
  })

  document.body.removeChild(tempContainer)

  return blobToFile(PDFBlob as Blob, `${fileName}.pdf`, 'application/pdf')
}

const transparentPng1x1 = () => 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='

const acCamargoNetwork = (id: string) => {
  if (!id) return false
  return ['ef90531c-85fb-13c7-0535-0efd62029a9b', '19fe80d2-8b7b-336b-1f11-fdae65b2dc0d', '5bb9f73e-968e-00d0-e774-462bf658649b'].includes(id)
}

const getSnackbarMessage = (message: string, type: 'success' | 'error') => {
  if (type === 'success') {
    return { show: true, text: message, icon: 'check_circle', color: '#43A047' }
  }
  return { show: true, text: message, icon: 'warning', color: '#C62828' }
}

const ApiRequestWithRetry = (
  fn: () => Promise<{ success?: boolean }>,
  retries = 1,
  delay = 0,
): Promise<any> => (async () => {
  let lastError: unknown

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const result = await fn()

      if (result && !result.success) {
        throw new Error('success=false')
      }

      return result
    } catch (error) {
      lastError = error
      if (attempt < retries && delay > 0) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise(r => setTimeout(r, delay))
      }
    }
  }

  throw lastError
})()


const convertMinutesToMs = (minutes: number | null | undefined, defaultMinutes: number = 90): number => {
  if (minutes === null || minutes === undefined || Number.isNaN(minutes) || minutes <= 0) {
    return defaultMinutes * 60 * 1000
  }
  return minutes * 60 * 1000
}

// Função auxiliar para formatar datas para ISO 8601
const formatDateToISO = (date: string | null | undefined): string | undefined => {
  if (!date || date === '') return undefined
  // Se já está no formato ISO, retorna como está
  if (date.includes('T')) return date
  // Se está no formato YYYY-MM-DD, adiciona T00:00:00
  if (date.match(/^\d{4}-\d{2}-\d{2}$/)) return `${date}T00:00:00`
  return date
}

// Função auxiliar para garantir que origemDaSolicitacao seja um array de strings
const normalizeOrigemDaSolicitacao = (origem: string | string[] | null | undefined): string[] | undefined => {
  if (!origem || origem === '') return undefined
  if (Array.isArray(origem)) {
    return origem.length > 0 ? origem : undefined
  }
  return [origem]
}

// Função auxiliar para validar se um valor não está vazio
const hasValue = (value: any): boolean => {
  if (value === null || value === undefined || value === '') return false
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'boolean') return true
  return true
}

const buildQueryParams = (params: Record<string, string | null | undefined>) => new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== null && value !== undefined && value !== '',
    ) as [string, string][],
).toString()

/**
 * Sincroniza o flag exigeConfirmacaoParaEnvioWhatsappNaCriacaoDePendencia
 * do resposta GET (Solicitacao.acoes) com o valor do POST
 * @param solicitacao A solicitação do GET (Solicitacao.acoes)
 * @param solicitacaoDoPost A solicitação do POST (Solicitacao.acoes)
 */
const syncWhatsAppFlagFromPost = (solicitacao: any, solicitacaoDoPost: any) => {
  if (solicitacao && solicitacao.acoes && solicitacaoDoPost && solicitacaoDoPost.acoes) {
    solicitacao.acoes.exigeConfirmacaoParaEnvioWhatsappNaCriacaoDePendencia =
      solicitacaoDoPost.acoes.exigeConfirmacaoParaEnvioWhatsappNaCriacaoDePendencia
  }
}

const idadeGestacionalMax = 42

const limitarIdadeGestacionalCommon = (value: number, setValue: (max: number) => void): void => {
  if (value > idadeGestacionalMax) {
    setValue(idadeGestacionalMax)
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Idade gestacional informada é maior que ${idadeGestacionalMax} semanas. O valor foi ajustado para ${idadeGestacionalMax}.`,
      icon: 'warning',
      color: '#C62828',
      timeout: 5000,
    })
  }
}

export {
  getRoute,
  backofficeRoute,
  lembreteColor,
  timeout,
  adjustTZ,
  capitalizeCase,
  splitUppercase,
  humanTime,
  formatDateTimePost,
  instrumentador,
  lightenDarkenColor,
  dateToTimestamp,
  formatDate,
  onlyNumber,
  onlyNumberAndNewLine,
  onlyAlphaNumeric,
  formatDateGetApi,
  isDateValid,
  assinarEnviar,
  maskDate,
  maskDateMonth,
  maskMoney,
  maskHour,
  maskPhone,
  formatPhoneApi,
  isRolesValid,
  formatDateTimeSendApi,
  formatDateOnly,
  maskDateTime,
  groupCollectionByField,
  groupCollectionByDay,
  groupCollectionByWeek,
  groupCollectionByMonth,
  toggleHtmlOverflow,
  displayColorBySituation,
  displayColorByStatus,
  stringToDecimal,
  decimalToString,
  objectKeysToCamelCase,
  getUser,
  getUserDefaultBackofficeArea,
  validateLength,
  validateEmail,
  validateEmailForm,
  validateCPF,
  validateCNPJ,
  validateCPFCNPJ,
  validateTelefone,
  validateTelefoneForm,
  validateDate,
  validateGUID,
  tipoAnestesiaToTemp,
  outrosTipoAnestesiaToTemp,
  formatToSendTipoAnestesia,
  formatPhoneMask,
  verifyEtapaAgendamento,
  verifyAcoesAgendamento,
  verifyAcoesFarmacia,
  verifyAcaoPrincipalAgendamento,
  verifyEtapaAutorizacao,
  verifyEtapaOrcamento,
  verifyEtapaAgenciaTransfusional,
  verifyEtapaSuprimentos,
  timeoutDefault,
  displayColorPrestadorRecebimentoBySituation,
  displayColorCalculoRecebimentoBySituation,
  isMobile,
  getOrientation,
  maskCPFCNPJ,
  clearCPF,
  clearReservaDeSangue,
  onlyFloat,
  isDecimal,
  clearEmptyFields,
  truncateText,
  displayLateralidade,
  convertToGradeMedicaEvento,
  setOPMEsToSave,
  isEqual,
  isEmpty,
  generateGUID,
  getPrimeiraEtapaAgendamento,
  getConfigObject,
  ptBrDateStringToDate,
  getAgendamentoStatuses,
  formatProcedimentosUpdateSolicitacao,
  getProcedimentoIdFromProcedimentos,
  bytesToMegabytes,
  displayRoboAutorizacao,
  toHttpParams,
  getUfs,
  isNull,
  getColorFromReservaSala,
  flatPhone,
  setMateriaisCotadosOpme,
  getOpmesApagados,
  setValorDoCampoUnico,
  canShowSeloNaoSegueOProtocoloHardCoded,
  contains,
  minutesToHours,
  getHospitalAreaName,
  handleEspecialidades,
  getDateTimeCurrentWeekByWeekdayString,
  parseShiftInfo,
  opcaoHabilitadoShared,
  campoHabilitadoShared,
  createLinearGradientByTimeDifference,
  getSingleDate,
  handleCalendarResources,
  handleCalendarEvents,
  displayCategoriaDoPlanoParaFidelizacao,
  aceiteMedicoDaAutorizacaoParcialSeAplica,
  filtrarItensPorAcao,
  getWeekdayByDate,
  replaceRange,
  hideEmail,
  allowOnlyNumbersThatDoNotStartWithZero,
  allowOnlyNumbersBetweenRange,
  dateRangeOverlap,
  formatStatusSituacaoFarmacia,
  base64toBlob,
  classByTipoReservaSala,
  classByComplexidadeReservaSala,
  cpfOuStringComum,
  maskPhoneNumber,
  formatAnonymizedPhoneNumber,
  formatHemocomponenteName,
  blobToFile,
  transparentPng1x1,
  createPDFWithMultiplePagesGeneration,
  acCamargoNetwork,
  getSnackbarMessage,
  ApiRequestWithRetry,
  convertMinutesToMs,
  displayColorByStatusGeracaoRepasse,
  formatDateToISO,
  normalizeOrigemDaSolicitacao,
  hasValue,
  buildQueryParams,
  syncWhatsAppFlagFromPost,
  idadeGestacionalMax,
  limitarIdadeGestacionalCommon,
}
